import nomes from './../nomesExtenso/nomes';
import { getGroup, numberInFull } from './../common';

function porExtenso(numero) {
    let numberStr = numero.toString().split('.'),
        numberBefore = +numberStr[0] || 0,
        numberAfter = +numberStr[1] || 0;

    let numberBeforeExtended = (numero < 0 ? 'menos ' : '') + numberInFull(numberBefore.toString().replace('-', ''));
    let numberAfterExtended = '';

    if (numberAfter) {
        if (numberAfter >= -999 && numberAfter <= 999)
            numberAfterExtended = numberInFull(numberAfter);
        else
            numberAfterExtended = numberAfter.toString().split('').map(x => nomes[0][+x]).join(' ');
    }

    return numberBeforeExtended + (numberAfter > 0 ? ' vírgula ' + numberAfterExtended : '');
}

export default porExtenso;



// WEBPACK FOOTER //
// ./src/app/shared/helpers/numberToWord/lib/estilos/normal.ts